export const defaultDataModal = {
  open: false,
  title: '',
  component: '',
  params: {}
}

export const defaultDataUser = {
  user_name: '',
  user_lastname: '',
  email: '',
  password: '',
  repeat_password: '',
  rol: ''
}
